import React from 'react'
import { Route, Redirect, withRouter } from 'react-router-dom'
import { getProfile, getAuthInfo, initAuth, logout, authToken } from 'webmango-core/effects/auth'
import { fetchWorkspaceList } from 'webmango-core/effects/workspace'
import cx from 'classnames'
import LoginForm from './Form'
import WorkspaceRegister from './Workspace/Register'
import WorkspaceSelect from './Workspace/Select'
import withErrorBoundary from '../ErrorBoundary'

import './index.css'
import '../Layout.css'

export default withErrorBoundary(withRouter(class Login extends React.PureComponent {
  initialState = {
    isSignedIn: undefined,
    alreadySignedIn: undefined,
    profile: undefined,
    isVerifying: undefined,
    isVerified: undefined,
    workspaces: undefined,
    identities: undefined,
    authProfile: undefined
  }

  state = { ...this.initialState }

  async componentWillMount () {
    try {
      await initAuth()
      this.setState({
        config: await getAuthInfo().catch(this.onError)
      })
    } catch (error) {
      this.onError(error)
    }
  }

  onSuccess = async (authProfile, accessToken) => {
    if (!accessToken) return this.onSignOut()
    this.setState({
      authProfile,
      isSignedIn: true,
      isVerifying: true,
      error: undefined
    })
    let isVerified = false
    try {
      await authToken({ accessToken })
      isVerified = true
    } catch (error) {
      this.onError(error)
      this.onSignOut()
    }

    this.setState({ isVerifying: false })

    if (isVerified) {
      try {
        await this.updateData()
        this.setState({
          isVerified: true
        })
        this.props.history.push(`/workspaces${window.location.search || ''}`)
      } catch (error) {
        this.onCrash(error)
      }
    }
  }

  componentDidCatch (error, info) {
    this.onCrash(error, info)
  }

  onCrash (error, info) {
    this.onError(error)
    this.onSignOut()
  }

  updateData = async () => {
    return Promise.all([
      this.updateProfile(),
      this.updateWorkspaces()
    ])
  }

  updateProfile = async () => {
    const profile = await getProfile()

    if (profile) {
      this.setState(({ workspace }) => {
        if (workspace) return { profile }
        workspace = profile.workspace || Object.keys(profile.workspaces)[0]
        const params = new URLSearchParams(window.location.search)
        const redirect = params.get('redirect')
        if (redirect) {
          const redirectParts = redirect.split('/').filter(Boolean)
          if (redirectParts[0] === 'w' && redirectParts[1]) {
            workspace = redirectParts[1]
          }
        }

        return {
          profile,
          workspace
        }
      })
    }
  }

  updateWorkspaces = async () => {
    const { identities, workspaces } = await fetchWorkspaceList()
    this.setState({
      workspaces,
      identities
    })
  }

  onSignOut = async () => {
    this.setState(this.initialState)
    await logout()
  }

  onError = (error, info) => {
    if (error && error.error === 'popup_closed_by_user') return
    console.error('Error', { error, info })
    this.setState({ error })
  }

  onRegisterComplete = async ({ id }) => {
    await this.updateData()
    this.setState({ workspace: id })
    this.props.history.push(`/workspaces${window.location.search || ''}`)
  }

  getRedirect () {
    const { pathname } = this.props.location
    const { isVerified, profile } = this.state

    let dest
    if (!isVerified) {
      dest = '/'
    } else {
      // go to /register if no workspaces
      if (pathname === '/workspaces' && profile && !Object.keys(profile.workspaces).length) {
        dest = '/register'
      }
    }

    if (dest && pathname !== dest) {
      return (
        <Redirect
          to={{
            pathname: dest,
            search: window.location.search
          }}
        />
      )
    }
  }

  render () {
    const params = new URLSearchParams(window.location.search)
    const redirect = params.get('redirect')

    return (
      <div className='Login'>
        <h1>
          WebMango
          {redirect && redirect.startsWith('sample-import/') && (
            <span className='headingInfo'>
              Preparing to import data from Plexus
            </span>
          )}
        </h1>
        <div
          className={cx('LoginBody', {
            root: this.props.location.pathname === '/',
            workspaces: this.props.location.pathname === '/workspaces',
            register: this.props.location.pathname === '/register'
          })}
        >
          <Route
            exact
            path='/'
            children={({ match }) => (
              <div className={cx('showable', { show: match })}>
                <LoginForm
                  {...this.state}
                  onSuccess={this.onSuccess}
                  onFailure={this.onError}
                />
              </div>
            )}
          />
          <Route
            exact
            path='/workspaces'
            children={({ match }) => (
              <div className={cx('showable', { show: match })}>
                <WorkspaceSelect
                  {...this.state}
                  onSignOut={this.onSignOut}
                  setState={this.setState.bind(this)}
                  updateData={this.updateData}
                />
              </div>
            )}
          />
          <Route
            exact
            path='/register'
            children={({ match }) => (
              <div className={cx('showable', { show: match })}>
                <WorkspaceRegister
                  {...this.state}
                  onSignOut={this.onSignOut}
                  updateData={this.updateData}
                  setState={this.setState.bind(this)}
                  onComplete={this.onRegisterComplete}
                />
              </div>
            )}
          />
          {this.getRedirect()}
        </div>
      </div>
    )
  }
}))



// WEBPACK FOOTER //
// ./src/components/Login/index.js